<template>
  <div>
    <base-header class="header pb-8 pt-5 pt-lg-8">
      <!-- Mask -->
      <span class="mask bg-gradient-warning opacity-8"></span>
      <!-- Header container -->
      <div class="container-fluid">
        <div class="row">
          <div class="col-12 mt-0 mt-md-4 mt-lg-0">
            <router-link
              to="/startup/chamadas"
              class="btn-link font-weight-normal text-white"
              ><i class="fas fa-chevron-left mr-1"></i> Voltar</router-link
            >
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col-12">
          <card shadow type="secondary">
            <div slot="header" class="bg-white border-0">
              <div class="row align-items-center">
                <div class="col-12">
                  <h3 class="mb-0">Ficha de inscrição</h3>
                </div>
              </div>
            </div>
            <template>
              <!-- INFORMAÇÕES BÁSICAS DA STARTUP -->
              <div class="text-center">
                <div class="row ml-1">
                  <h6 class="heading-small text-muted mb-5">
                    Informações básicas da startup
                    <base-button
                      size="sm"
                      type="link"
                      class="p-0 m-0 ml-2"
                      @click="$router.push('/startup/configuracoes')"
                    >
                      Editar
                    </base-button>
                  </h6>
                </div>
                <div class="row">
                  <div class="col-lg-5 text-center">
                    <div class="card-profile-image mt-4">
                      <img :src="getStartupLogoPath" class="card-image" />
                    </div>
                    <div class="mt-8 pt-2">
                      <h2 class="text-orange mb-1">
                        {{ startup.name }}
                      </h2>
                      <div>
                        <div class="h5 font-weight-300 mb-1">
                          <i class="ni ni-pin-3 mr-2"></i
                          >{{ startup.city || "..." }},
                          {{ startup.state || "..." }}
                        </div>
                        <div class="h5 mt-2">
                          <badge type="info">
                            {{ startup.sector }}
                          </badge>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-lg-7 text-lg-left text-md-center mt-md-2 startup_basic_info"
                  >
                    <div class="col mb-lg-2 mt-md-2">
                      <label>Data de fundação:</label>
                      {{ formatDate(startup.foundation) }}
                    </div>
                    <div class="col mb-lg-2">
                      <label>Estágio de maturidade atual da startup:</label>
                      {{ stages[startup.stage] || startup.stage }}
                    </div>
                    <div class="col mb-lg-2">
                      <label>One-line pitch:</label>
                      <p class="ml-2 text-sm">
                        <i class="fas fa-quote-left mr-2"></i
                        >{{ startup.one_sentence_pitch
                        }}<i class="fas fa-quote-right ml-2"></i>
                      </p>
                    </div>
                    <div class="col-12 mb-2">
                      <badge type="warning" v-if="!startup.logo"
                        >Lembre-se de atualizar o logo da startup nas
                        configurações.</badge
                      >
                    </div>
                  </div>
                </div>
              </div>
              <hr class="my-4" />
              <!-- STARTUP -->
              <div>
                <div class="row ml-1">
                  <h6 class="heading-small text-muted mb-4">
                    Informações da startup
                  </h6>
                </div>
                <div>
                  <div class="row ml-0 ml-lg-2">
                    <div class="col-lg-6">
                      <base-input label="CNPJ da startup (opcional)">
                        <the-mask
                          :mask="['##.###.###/####-##']"
                          v-model="model.subscription.startup_cnpj"
                          class="form-control"
                          type="tel"
                          placeholder="Digite o CNPJ da startup"
                        ></the-mask>
                      </base-input>
                    </div>
                    <div class="col-lg-6">
                      <base-input
                        label="Website da startup (opcional)"
                        v-model="websiteLink"
                        type="text"
                        placeholder="Digite o melhor Website da sua startup"
                      />
                    </div>
                    <div class="col-lg-12">
                      <base-input
                        label="Quais são os desafios mais significativos que sua empresa enfrenta atualmente?"
                      >
                        <textarea
                          rows="2"
                          v-model="model.subscription.startup_problem"
                          class="form-control"
                          placeholder="Digite aqui..."
                        >
                        </textarea>
                      </base-input>
                    </div>
                    <div class="col-lg-12">
                      <label for="" class="form-control-label"
                        >A startup já participou da seleção em outro Batch da
                        Stars? Caso sim, quando?</label
                      >
                      <textarea
                        rows="2"
                        v-model="model.subscription.already_participated_batch"
                        class="form-control"
                        placeholder="Digite aqui."
                      >
                      </textarea>
                    </div>
                    <div class="col-lg-12 mt-4">
                      <label for="" class="form-control-label"
                        >De que forma você espera que a Stars possa auxiliar a
                        sua startup?</label
                      >
                      <textarea
                        rows="2"
                        v-model="model.subscription.how_can_stars_help"
                        class="form-control"
                        placeholder="Digite aqui."
                      >
                      </textarea>
                    </div>
                    <div class="col-lg-6 mt-4">
                      <base-input
                        label="Nome completo do responsável"
                        v-model="model.subscription.responsible_name"
                        placeholder="Digite o nome completo do responsável"
                      />
                    </div>
                    <div class="col-lg-6 mt-md-4">
                      <label class="form-control-label"
                        >Celular ou telefone (com DDD) do responsável</label
                      >
                      <base-input addonLeftIcon="fab fa-whatsapp">
                        <the-mask
                          :mask="['(##) ####-####', '(##) #####-####']"
                          v-model="model.subscription.responsible_phone"
                          class="form-control"
                          type="tel"
                          placeholder="Celular ou telefone (com DDD)"
                        ></the-mask>
                      </base-input>
                    </div>
                    <div class="col-lg-6 mt-1">
                      <span class="form-control-label"
                        >E-mail do responsável</span
                      >
                      <base-input
                        addon-left-icon="ni ni-email-83"
                        v-model="model.subscription.responsible_email"
                        placeholder="exemplo@minhastartup.com"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <hr class="my-4" />
              <!-- NEGÓCIO -->
              <div>
                <div class="row ml-1">
                  <h6 class="heading-small text-muted mb-4">
                    Informações do negócio
                  </h6>
                </div>
                <div>
                  <div class="row ml-0 ml-lg-2">
                    <div class="col-lg-6">
                      <base-input
                        label="Qual o modelo de negócios de sua startup?"
                      >
                        <select
                          class="form-control"
                          v-model="
                            model.subscription.product_bussiness_strategy
                          "
                        >
                          <option value="" selected disabled>
                            Selecione uma opção
                          </option>
                          <option
                            v-for="option in bussinesModels"
                            :key="option"
                            :value="option"
                          >
                            {{ option }}
                          </option>
                        </select>
                      </base-input>
                    </div>
                    <div class="col-lg-6">
                      <base-input
                        label="e o valor de faturamento do último trimestre?"
                        type="number"
                        step="1"
                        placeholder="Digite o faturamento dos últimos 3 meses"
                        v-model="model.subscription.last_quarters_revenue"
                        v-on:keypress="isNumber($event)"
                      />
                    </div>
                    <div class="col-lg-6">
                      <base-input
                        label="Qual a maior vantagem competitiva da sua startup frente às soluções existentes no mercado atual?"
                      >
                        <textarea
                          rows="2"
                          v-model="
                            model.subscription.product_competitive_advantage
                          "
                          class="form-control form-control"
                          placeholder="Qual é sua vantagem competitiva? e.g. pioneirismo, conhecimento especializado, tecnologia proprietária, patantes, ..."
                        >
                        </textarea>
                      </base-input>
                    </div>
                    <div class="col-lg-6">
                      <base-input
                        label="Qual é o problema ou necessidade específica dos clientes que sua empresa busca resolver?"
                      >
                        <textarea
                          rows="2"
                          v-model="model.subscription.product_market_problem"
                          class="form-control form-control"
                          placeholder="Brevemente, qual o principal problema de mercado seu produto ou serviço resolve?"
                          style="white-space: pre-line"
                        >
                        </textarea>
                      </base-input>
                    </div>
                    <div class="col-lg-12">
                      <label for="" class="form-control-label"
                        >Como está o captable atual?</label
                      >
                      <p class="description">
                        Listar nomes dos sócios-empreendedores, o nível de
                        dedicação de cada um (integral ou parcial), percentual
                        do negócio e responsabilidade de cada um na startup. Se
                        houver sócio-investidor, se possível, listar nome e
                        percentual. Também incluir, se houver, o link do
                        LinkedIn dos sócios-empreendedores.
                      </p>
                      <div
                        v-for="(partner, index) in model.subscription
                          .startup_equity"
                        :key="index"
                        class="border rounded p-3 mb-3"
                        style="background-color: #f8f9fa"
                      >
                        <div
                          class="d-flex justify-content-between align-items-center mb-3"
                        >
                          <h6 class="mb-0">Sócio {{ index + 1 }}</h6>
                          <base-button
                            v-if="model.subscription.startup_equity.length > 1"
                            type="danger"
                            size="sm"
                            @click="removeSocio(index)"
                            :iconOnly="true"
                            icon="fas fa-trash"
                          ></base-button>
                        </div>
                        <div class="row">
                          <div class="col-lg-6">
                            <base-input
                              label="Nome completo"
                              type="text"
                              placeholder="Digite o nome completo do sócio"
                              v-model="partner.name"
                            />
                          </div>
                          <div class="col-lg-6">
                            <base-input
                              label="Dedicação (integral/parcial)"
                              type="text"
                              placeholder="Escreva a dedicação do sócio"
                              v-model="partner.dedication"
                            />
                          </div>
                          <div class="col-lg-6">
                            <base-input
                              label="Percentual da sociedade"
                              type="text"
                              placeholder="Insira o percentual da sociedade"
                              v-model="partner.percentage"
                            />
                          </div>
                          <div class="col-lg-6">
                            <base-input
                              label="Função na startup"
                              type="text"
                              placeholder="Insira a função do sócio na startup"
                              v-model="partner.role"
                            />
                          </div>
                          <div class="col-lg-12">
                            <base-input
                              label="LinkedIn (opcional)"
                              type="url"
                              placeholder="Insira o link do LinkedIn do sócio"
                              v-model="partner.linkedin"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="text-center mt-3">
                        <base-button
                          type="success"
                          size="sm"
                          @click="addNewSocio"
                        >
                          <i class="fas fa-plus mr-1"></i>
                          Adicionar Sócio
                        </base-button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <hr class="my-4" />
              <!-- MERCADO -->
              <div>
                <div class="row ml-1">
                  <h6 class="heading-small text-muted mb-4">
                    Informações de mercado
                  </h6>
                </div>
                <div>
                  <div class="row ml-0 ml-lg-2">
                    <div class="col-lg-6">
                      <base-input
                        label="Qual o tamanho do mercado (em reais)?"
                        type="number"
                        step="1"
                        placeholder="Digite o tamanho do mercado"
                        v-model="model.subscription.product_market_cap"
                        v-on:keypress="isNumber($event)"
                      />
                    </div>
                    <div class="col-lg-6">
                      <base-input
                        label="Quantos clientes ativos vocês possuem?"
                        type="number"
                        step="1"
                        placeholder="Digite o número de clientes ativos"
                        v-model="model.subscription.active_clients"
                        v-on:keypress="isNumber($event)"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <hr class="my-4" />
              <!-- PROPOSTA -->
              <div>
                <div class="row ml-1">
                  <h6 class="heading-small text-muted mb-4">
                    Proposta de investimento
                  </h6>
                </div>
                <div>
                  <div class="row ml-0 ml-lg-2">
                    <div class="col-lg-6">
                      <base-input
                        label="Valor de investimento buscado (em reais)"
                        type="number"
                        step="1"
                        placeholder="Digite o valor buscado"
                        v-model="model.subscription.investment_sought"
                        v-on:keypress="isNumber($event)"
                      />
                    </div>
                    <div class="col-lg-6">
                      <base-input
                        label="Percentual de equity oferecido (%)"
                        type="text"
                        placeholder="Digite o percentual (ex: 10%)"
                        v-model="model.subscription.equity_offered"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <hr class="my-4" />
              <!-- Pitch vídeo -->
              <div>
                <div class="row ml-1">
                  <h6 class="heading-small text-muted mb-4">
                    Pitch video (opcional)
                  </h6>
                </div>
                <div>
                  <div class="row ml-0 ml-lg-2 d-flex align-items-center">
                    <p class="text-muted ml-3 mt-0">
                      <i class="fab fa-youtube mr-2"></i> deve ser um vídeo no
                      <b class="font-weight-bold">YouTube</b> (com
                      compartilhamento de link e preferencialmente não listado)
                      de até <b class="font-weight-bold">3 minutos</b> de
                      duração,
                      <b class="font-weight-bold">gravado na horizontal</b>.
                    </p>
                    <div class="col-md-6">
                      <base-input
                        class="mb-1"
                        v-model="pitch_video_url"
                        placeholder="Cole aqui o link do vídeo no YouTube"
                      />
                    </div>
                    <div class="col-md-6 mb-3" v-show="pitch_video_url">
                      <span
                        v-if="getYoutubeVideoId()"
                        @click="
                          openLink(
                            'https://www.youtube.com/watch?v=' +
                              getYoutubeVideoId()
                          )
                        "
                        v-tooltip="
                          'Verifique se o vídeo está abrindo corretamente.'
                        "
                        class="btn btn-default btn-sm"
                        >verificar link</span
                      >
                      <span
                        v-else
                        class="text-sm text-warning"
                        v-tooltip="
                          `Uma URL válida possuí um formato do tipo <em>https://www.youtube.com/watch?v=<b>ID</b></em>, onde <em><b>ID</b></em> é o indentificador do vídeo.`
                        "
                        ><i class="fas fa-info-circle mr-1"></i> A URL ainda não
                        está em um formato válido</span
                      >
                    </div>
                  </div>
                </div>
              </div>
              <hr class="my-4" />
              <!-- Pitch deck -->
              <div>
                <div class="row d-block ml-1">
                  <h6 class="heading-small text-muted mb-4">
                    Pitch deck (opcional)
                    <a
                      v-if="startup.subscription && startup.subscription.deck"
                      :href="startup.subscription.deck.url"
                      target="_blank"
                      class="btn btn-sm btn-primary float-right"
                    >
                      <i class="fas fa-file-download"></i> Baixar deck atual
                    </a>
                  </h6>
                </div>
                <div>
                  <div class="row ml-0 ml-lg-2 d-flex align-items-center">
                    <p class="text-muted ml-3 mt-0">
                      <i class="far fa-file-pdf mr-2"></i> deve ser uma
                      apresentação em
                      <b class="font-weight-bold">formato PDF</b>. O arquivo
                      deve ter um
                      <b class="font-weight-bold">tamanho máximo de 15mb</b>.
                    </p>
                    <div class="col-12">
                      <file-select
                        v-model="model.presentation.pitch_deck"
                        title="Selecionar novo pitch deck"
                        accept="application/pdf"
                        type="dark"
                        :mbSize="15"
                      ></file-select>
                      <p class="text-sm text-muted d-inline-block mx-3">
                        <i class="fas fa-info-circle mr-1"></i>
                        <span v-if="!model.presentation.pitch_deck"
                          >Deve possuir tamanho máximo de <b>15MB</b>.</span
                        ><span v-else
                          >Arquivo selecionado. Tamanho:
                          <b>{{
                            getMbSize(model.presentation.pitch_deck.size)
                          }}</b
                          >. Extensão:
                          <b
                            >.{{
                              model.presentation.pitch_deck.name
                                .split(".")
                                .pop()
                            }}</b
                          >.</span
                        >
                      </p>
                    </div>
                    <p class="pt-2">
                      <b>#Dica</b>: Confirme se seu pitch deck responde as
                      seguintes perguntas:
                    </p>
                    <ul class="description">
                      <li>Qual o problema de mercado?</li>
                      <li>
                        Como essa dor é endereçada hoje? (ex: concorrentes
                        diretos e indiretos)
                      </li>
                      <li>
                        Como sua startup resolve o problema? (reforce os
                        diferencias competitivos)
                      </li>
                      <li>Qual o tamanho de mercado?</li>
                      <li>Quem é o time fundador?</li>
                      <li>
                        Quanto busca de investimento por quanto de equity?
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <hr class="my-4" />
              <div v-if="error" class="text-center">
                <base-alert type="danger"
                  ><i class="fas fa-exclamation-circle mr-1"></i>
                  {{ error }}</base-alert
                >
              </div>
              <div v-if="success" class="text-center">
                <base-alert type="success"
                  ><i class="fas fa-thumbs-up mr-1"></i>
                  {{ success }}</base-alert
                >
              </div>
              <div class="row">
                <div class="col-12 text-center">
                  <base-button
                    type="primary"
                    :custom="true"
                    @click="handleSubmit"
                  >
                    Salvar alterações
                  </base-button>
                </div>
              </div>
            </template>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/services/api.js";
import { getIdFromUrl } from "vue-youtube";

export default {
  name: "inscricao-view",
  data() {
    return {
      model: {
        subscription: {
          id: "",
          responsible_name: "",
          responsible_phone: "",
          responsible_email: "",
          startup_cnpj: "",
          startup_equity: [
            {
              name: "",
              dedication: "",
              percentage: "",
              role: "",
              linkedin: "",
            },
          ],
          startup_problem: "",
          product_development_stage: "",
          product_bussiness_strategy: "",
          product_more_information: [{ title: "site", link: "" }],
          product_market_problem: "",
          product_competitive_advantage: "",
          startup_number_partners: 0,
          startup_number_employees: 0,
          already_participated_batch: "",
          how_can_stars_help: "",
          last_quarters_revenue: "",
          last_month_revenue: "",
          last_year_revenue: "",
          product_market_cap: "",
          active_clients: "",
          investment_sought: "",
          equity_offered: "",
        },
        presentation: {
          pitch_youtube_video_id: "",
          pitch_deck: null,
        },
      },
      pitch_video_url: "",
      startup: {
        city: "",
        state: "",
        foundation: "",
        how_meet_stars: "",
        name: "",
        one_sentence_pitch: "",
        sector: "",
        stage: "",
        logo: "",
        subscription: {
          deck: "",
        },
      },
      notRequiredFields: {
        startup_cnpj: true,
        responsible_cpf: true,
        startup_is_incubated: true,
        product_name: true,
        product_sector: true,
        product_description: true,
        product_development_stage: true,
        product_launch_date: true,
        product_own_technology: true,
        product_more_information: true,
        product_target_market: true,
        startup_number_partners: true,
        startup_number_employees: true,
        startup_partners_description: true,
        startup_team_description: true,
        already_participated_batch: true,
      },
      error: "",
      success: "",
      bussinesModels: [
        "E-commerce",
        "Marketplace (take rate)",
        "PPU (Pay per use)",
        "SaaS (Software as a Service)",
        "% sobre ganho do cliente (Success Fee)",
        "Com base em audiência/propaganda (Audience/Ads based)",
        "Outros",
      ],
      stages: {
        concept: "Ideação",
        validation: "Validação",
        traction: "Tração",
        scale: "Escala",
        other: "Outro",
      },
    };
  },
  async mounted() {
    const loader = this.$loading.show({ width: 140, height: 140 });
    try {
      let subscriptionId = this.$route.params.id;

      if (!subscriptionId) {
        const { data } = await api.get("/startup-call-subscriptions/");
        if (!data || !data.length)
          throw new Error("Nenhuma inscrição encontrada");
        subscriptionId = data[0].id;
        this.$router.replace(`/startup/inscricao/${subscriptionId}/editar`);
        return;
      }

      const { data: startup } = await api.get(
        `/startup-call-subscriptions/${subscriptionId}`
      );

      const subscription = startup.subscription;

      if (subscription.product_more_information) {
        try {
          const parsed = JSON.parse(subscription.product_more_information);
          subscription.product_more_information = Array.isArray(parsed)
            ? parsed
            : [parsed];
        } catch (e) {
          subscription.product_more_information = [
            {
              title: "site",
              link: subscription.product_more_information || "",
            },
          ];
        }
      } else {
        subscription.product_more_information = [{ title: "site", link: "" }];
      }

      if (subscription.startup_equity) {
        try {
          const parsed = JSON.parse(subscription.startup_equity);
          if (Array.isArray(parsed)) {
            subscription.startup_equity = parsed.map((partner) => ({
              name: partner.name || "",
              dedication: partner.dedication || "",
              percentage: partner.percentage || "",
              role: partner.role || "",
              linkedin: partner.linkedin || "",
            }));
          } else {
            subscription.startup_equity = [
              {
                name: parsed.name || "",
                dedication: parsed.dedication || "",
                percentage: parsed.percentage || "",
                role: parsed.role || "",
                linkedin: parsed.linkedin || "",
              },
            ];
          }
        } catch (e) {
          subscription.startup_equity = this.parsePartnersFromText(
            subscription.startup_equity
          );
        }
      } else {
        subscription.startup_equity = [
          {
            name: "",
            dedication: "",
            percentage: "",
            role: "",
            linkedin: "",
          },
        ];
      }

      for (const key of Object.keys(subscription)) {
        if (key in this.model.subscription) {
          this.model.subscription[key] = subscription[key];
        }
      }

      if (subscription.startup_pitch_video_youtube_id)
        this.pitch_video_url = this.getUrl(
          subscription.startup_pitch_video_youtube_id
        );

      Object.assign(this.startup, startup);
    } catch (e) {
      this.$toasted.error("Ocorreu um erro ao recuperar as informações");
      this.$router.push(`/startup/chamadas/inscricoes`);
    }
    loader.hide();
  },
  methods: {
    async handleSubmit() {
      const loader = this.$loading.show({ width: 140, height: 140 });
      this.error = this.success = "";

      if (!this.isValidModel) {
        this.error = "Por favor, preencha todos os campos obrigatórios.";
        loader.hide();
        return;
      }

      const partnerValidation = this.validatePartners();
      if (!partnerValidation.isValid) {
        this.error = partnerValidation.message;
        loader.hide();
        return;
      }

      const subscriptionData = { ...this.model.subscription };

      if (Array.isArray(subscriptionData.product_more_information)) {
        subscriptionData.product_more_information = JSON.stringify(
          subscriptionData.product_more_information[0] || {
            title: "site",
            link: "",
          }
        );
      }

      if (Array.isArray(subscriptionData.startup_equity)) {
        const socios = subscriptionData.startup_equity
          .map(
            (p) =>
              `Nome: ${p.name}\n` +
              `Dedicação: ${p.dedication}\n` +
              `Percentual da sociedade: ${p.percentage}\n` +
              `Função na startup: ${p.role}\n` +
              `LinkedIn: ${p.linkedin}`
          )
          .join("\n\n");
        subscriptionData.startup_equity = socios;
      }

      if (this.pitch_video_url) {
        subscriptionData.startup_pitch_video_youtube_id =
          this.getYoutubeVideoId();
      }

      try {
        if (this.model.presentation.pitch_deck) {
          await this.submitDeck(subscriptionData.id);
        }

        await api.put(
          `/startup-call-subscriptions/${subscriptionData.id}`,
          subscriptionData
        );

        this.success = "Sua inscrição foi atualizada com sucesso.";
        this.$toasted.show("Inscrição atualizada com sucesso", {
          type: "success",
          duration: 5000,
        });
        setTimeout(() => {
          this.$router.push(`/startup/chamadas`);
        }, 2000);
      } catch (e) {
        console.error("Erro ao atualizar inscrição:", e);
        this.error = "Ocorreu um erro ao atualizar a inscrição.";
        this.$toasted.error(this.error);
      }
      loader.hide();
    },
    async submitDeck(subscriptionId) {
      const deck = this.model.presentation.pitch_deck;
      if (!deck) return;

      try {
        const data = new FormData();
        data.append("deck", deck, deck.name);
        const config = {
          headers: {
            "content-type": "multipart/form-data",
          },
        };
        await api.post(
          `/startup-subscriptions/${subscriptionId}/decks`,
          data,
          config
        );
      } catch (e) {
        console.error("Erro ao submeter deck:", e);
        throw new Error("Erro ao submeter o deck");
      }
    },
    getUrl(youtubeVideoId) {
      if (!youtubeVideoId) return "";
      return `https://www.youtube.com/watch?v=${youtubeVideoId}`;
    },
    getYoutubeVideoId() {
      return getIdFromUrl(this.pitch_video_url);
    },
    openLink(link) {
      window.open(link, "file-window", "resizable=1,height=750,width=750");
    },
    getMbSize(bytes) {
      if (bytes < 1000) return `${bytes} bytes`;
      if (bytes < 1000 * 1000) return `${(bytes / 1000).toFixed(2)} KB`;
      return `${(bytes / 1000 / 1000).toFixed(2)} MB`;
    },
    formatDate(dateString) {
      if (!dateString) return "Não informado";
      try {
        const date = new Date(dateString);
        return date.toLocaleDateString("pt-BR");
      } catch (e) {
        return dateString;
      }
    },
    isNumber(e) {
      let char = String.fromCharCode(e.keyCode);
      if (/^[0-9]$/.test(char)) return true;
      else e.preventDefault();
    },
    addNewSocio() {
      this.model.subscription.startup_equity.push({
        name: "",
        dedication: "",
        percentage: "",
        role: "",
        linkedin: "",
      });
    },
    removeSocio(index) {
      if (this.model.subscription.startup_equity.length > 1) {
        this.model.subscription.startup_equity.splice(index, 1);
      }
    },
    parsePartnersFromText(partnersText) {
      if (!partnersText)
        return [
          {
            name: "",
            dedication: "",
            percentage: "",
            role: "",
            linkedin: "",
          },
        ];

      const partnersData = [];
      const blocks = partnersText.split("\n\n");

      for (const block of blocks) {
        if (block.trim()) {
          const lines = block.split("\n");
          const partner = {
            name: "",
            dedication: "",
            percentage: "",
            role: "",
            linkedin: "",
          };

          lines.forEach((line) => {
            if (line.startsWith("Nome: ")) {
              partner.name = line.replace("Nome: ", "").trim();
            } else if (line.startsWith("Dedicação: ")) {
              partner.dedication = line.replace("Dedicação: ", "").trim();
            } else if (line.startsWith("Percentual da sociedade: ")) {
              partner.percentage = line
                .replace("Percentual da sociedade: ", "")
                .trim();
            } else if (line.startsWith("Função na startup: ")) {
              partner.role = line.replace("Função na startup: ", "").trim();
            } else if (line.startsWith("LinkedIn: ")) {
              partner.linkedin = line.replace("LinkedIn: ", "").trim();
            }
          });

          if (
            partner.name ||
            partner.dedication ||
            partner.percentage ||
            partner.role
          ) {
            partnersData.push(partner);
          }
        }
      }

      return partnersData.length > 0
        ? partnersData
        : [
            {
              name: "",
              dedication: "",
              percentage: "",
              role: "",
              linkedin: "",
            },
          ];
    },
    validatePartners() {
      const partners = this.model.subscription.startup_equity;
      if (!partners || !Array.isArray(partners)) {
        return {
          isValid: false,
          message: "É necessário ter pelo menos um sócio.",
        };
      }

      for (let i = 0; i < partners.length; i++) {
        const partner = partners[i];
        const requiredPartnerFields = [
          "name",
          "dedication",
          "percentage",
          "role",
        ];

        for (const field of requiredPartnerFields) {
          if (!partner[field] || partner[field].trim() === "") {
            const fieldLabels = {
              name: "Nome",
              dedication: "Dedicação",
              percentage: "Percentual da sociedade",
              role: "Função na startup",
            };
            return {
              isValid: false,
              message: `Por favor, preencha o campo "${
                fieldLabels[field]
              }" do Sócio ${i + 1}.`,
            };
          }
        }
      }

      return { isValid: true, message: "" };
    },
  },
  computed: {
    getStartupLogoPath() {
      const defaultLogoPath = "/img/pages/default_logo.png";
      const startup = this.startup;
      if (!startup || !startup.logo) return defaultLogoPath;
      return startup.logo.url;
    },
    websiteLink: {
      get() {
        if (
          this.model.subscription.product_more_information &&
          this.model.subscription.product_more_information[0]
        ) {
          return this.model.subscription.product_more_information[0].link || "";
        }
        return "";
      },
      set(value) {
        if (!this.model.subscription.product_more_information) {
          this.model.subscription.product_more_information = [
            { title: "site", link: "" },
          ];
        }
        if (!this.model.subscription.product_more_information[0]) {
          this.model.subscription.product_more_information[0] = {
            title: "site",
            link: "",
          };
        }
        this.model.subscription.product_more_information[0].link = value;
      },
    },
    isValidModel() {
      const subscription = this.model.subscription;
      const requiredFields = [
        "responsible_name",
        "responsible_phone",
        "responsible_email",
      ];

      for (const field of requiredFields) {
        if (!subscription[field] || subscription[field].trim() === "") {
          return false;
        }
      }
      return true;
    },
  },
};
</script>

<style scoped>
.card-image {
  width: 140px;
  height: 140px;
  border-radius: 10%;
  margin: auto;
}
.startup_basic_info label {
  font-weight: bold;
}
.input-unit-box {
  position: relative;
}

.input-unit {
  display: block;
  border: 1px solid #d7d6d6;
  background: #fff;
  padding: 10px 30px 10px 10px;
}

.unit {
  position: absolute;
  display: block;
  right: 10px;
  top: 10px;
  z-index: 9;
  color: #444444;
}
</style>
